module.exports = __webpack_public_path__ + "img/7.ada6da16.jpg";